import type {
  RenewalAlert,
  RenewalDetails,
  RenewalPrime,
  RenewalStatus,
  RenewalTransaction,
} from '@policyvision/contracts';

import { Client } from '@/common/services/Client';

type RenewalNotePayload = {
  content: string;
  createdAt: string;
  createdByName: string;
  createdByUuid: string;
};

type RenewalDetailsPayload = {
  accountManagerName: string;
  alerts: RenewalAlert[];
  amendments: RenewalTransaction[];
  assignedToName: string;
  claims: RenewalTransaction[];
  contactEmail: string;
  contactFullName: string;
  contactPhone: string;
  enterpriseExternalLink: string;
  enterpriseLookupCode: string;
  enterpriseName: string;
  insurerName: string;
  notes: RenewalNotePayload[];
  primaryBrokerName: string;
  primes: RenewalPrime[];
  profitCenter: string;
  recommendations: RenewalTransaction[];
  status: RenewalStatus;
  type: string;
  uuid: string;
};

export async function fetchRenewalDetails(
  renewalUuid: string,
): Promise<RenewalDetails> {
  const response = await Client.get<RenewalDetailsPayload>({
    endpoint: `/renewals/${renewalUuid}`,
  });
  return {
    ...response.data,
    notes: response.data.notes.map((note) => ({
      ...note,
      createdAt: new Date(note.createdAt),
    })),
  };
}
